export default (theme) => ({
    root: {
        height: '100%',
        width: '100%',
        '& > div': {
            ...theme.utils.scrollbar,
        },
    },
    list: {},
});
